// extracted by mini-css-extract-plugin
module.exports = {"input":"InputPhone-module__input___3batS","button":"InputPhone-module__button___CyuSi","errors":"InputPhone-module__errors___18E9o"};